{
  "UPLOAD_KEY_REQUIRED": "The file key is required.",
  "UPLOAD_KEY_INVALID": "Invalid file key.",
  "UPLOAD_KEY_FORBIDDEN": "This key is outside the public folders.",
  "UPLOAD_FILE_REQUIRED": "A file is required.",
  "UPLOAD_PDF_REQUIRED": "A PDF file is required.",
  "UPLOAD_FILE_INVALID": "Invalid file. Check the file type and size.",
  "MEDIA_LESSON_NOT_FOUND": "Lesson not found.",
  "MEDIA_ATTACHMENT_NOT_FOUND": "Attachment not found.",
  "MEDIA_ATTACHMENT_DELETED": "Attachment deleted.",
  "MEDIA_NOT_FOUND": "Media not found.",
  "MEDIA_DELETED": "Media deleted.",
  "MEDIA_FILE_TYPE_NOT_ALLOWED": "File type not allowed.",
  "MEDIA_FILE_TOO_LARGE": "File is too large (max {{max}}).",
  "MEDIA_VIDEO_TYPE_NOT_ALLOWED": "Video type not allowed.",
  "MEDIA_VIDEO_TOO_LARGE": "Video is too large (max {{max}}).",
  "PAYMENTS_ACCESS_GROUP_REQUIRED": "An access group is required.",
  "PAYMENTS_OFFER_NOT_FOUND": "Offer not found.",
  "PAYMENTS_PURCHASE_NOT_FOUND": "Purchase not found.",
  "PAYMENTS_GATEWAY_NOT_SUPPORTED": "Payment gateway not supported.",
  "PAYMENTS_WEBHOOK_UNAVAILABLE": "{{gateway}} webhook unavailable: secret not configured.",
  "PAYMENTS_WEBHOOK_SECRET_INVALID": "Invalid webhook secret.",
  "GURU_NOT_CONFIGURED": "Guru is not configured.",
  "GURU_CONNECTION_ESTABLISHED": "Connected to Guru!",
  "GURU_TOKEN_INVALID": "Invalid or expired token.",
  "GURU_HTTP_ERROR": "Guru returned status {{status}}.",
  "GURU_CONNECTION_FAILED": "Couldn't connect to Guru.",
  "INTEGRATION_NOT_FOUND": "Integration not found.",
  "FREEMIUM_USER_NOT_FOUND": "User not found.",
  "FREEMIUM_ALREADY_AT_TIER": "You're already on this plan.",
  "FREEMIUM_CANNOT_DOWNGRADE": "You can't downgrade your plan.",
  "FREEMIUM_UPGRADE_REQUEST_NOT_FOUND": "Upgrade request not found.",
  "FREEMIUM_UPGRADE_ALREADY_PROCESSED": "This upgrade request has already been processed.",
  "FREEMIUM_UPGRADE_FAILED": "Couldn't process the plan upgrade.",
  "FREEMIUM_UPGRADE_PAYMENT_REQUIRED": "Upgrade request created. Payment required.",
  "FREEMIUM_UPGRADE_PROCESSING": "Upgrade request created. Processing...",
  "FREEMIUM_ADMIN_UPGRADE_COMPLETED": "Admin upgrade completed successfully.",
  "FREEMIUM_CONTENT_REQUIRES_TIER": "This content requires the {{tier}} plan.",
  "FREEMIUM_COURSE_LIMIT_REACHED": "Course limit reached ({{max}} courses).",
  "FREEMIUM_LESSON_LIMIT_REACHED": "Monthly lesson limit reached ({{max}} lessons).",
  "FREEMIUM_DOWNLOADS_NOT_AVAILABLE": "Downloads aren't available on your plan.",
  "FREEMIUM_CERTIFICATES_NOT_AVAILABLE": "Certificates aren't available on your plan.",
  "FREEMIUM_AUTH_REQUIRED": "You need to be signed in.",
  "FREEMIUM_ACCESS_CHECK_FAILED": "Couldn't verify your access to this content.",
  "DOMAIN_NOT_FOUND": "Address not found.",
  "DOMAIN_IN_USE": "This address is already in use.",
  "DOMAIN_NO_VERIFICATION_TOKEN": "This address has no verification token.",
  "DOMAIN_PRIMARY_REQUIRES_VERIFIED": "Only a verified address can be the primary one.",
  "DOMAIN_PRIMARY_REMOVAL_BLOCKED": "Choose another address as primary before removing this one.",
  "DOMAIN_INVALID_FORMAT": "Invalid address. Use something like area.yourschool.com",
  "DOMAIN_INVALID": "Invalid address.",
  "ACCESS_GROUP_NOT_FOUND": "Access group not found.",
  "ACCESS_GROUP_HAS_ACTIVE_ENROLLMENTS": "Can't delete the group. There are {{count}} active enrollments.",
  "ACCESS_GROUP_DELETED": "Access group deleted successfully.",
  "ACCESS_GROUP_INTEGRATION_HAS_DEPENDENCIES": "Can't delete: there are linked purchases or affiliate links. Deactivate the integration instead.",
  "ACCESS_GROUP_INTEGRATION_REMOVED": "Integration removed successfully.",
  "ACCESS_GROUP_NO_PRODUCTS": "This access group has no products.",
  "ENROLLMENT_TARGET_REQUIRED": "Provide a product or an access group.",
  "ENROLLMENT_ALREADY_EXISTS": "User is already enrolled.",
  "ENROLLMENT_NOT_FOUND": "Enrollment not found.",
  "ENROLLMENTS_CREATED": "{{count}} enrollment(s) created successfully.",
  "IMPORT_CSV_REQUIRED": "A CSV file is required.",
  "IMPORT_EMAIL_REQUIRED": "Email is required.",
  "IMPORT_USER_NOT_FOUND": "User not found.",
  "WEBHOOK_NOT_FOUND": "Webhook not found.",
  "WEBHOOK_DELETED": "Webhook deleted successfully.",
  "WEBHOOK_TEST_SENT": "Test webhook sent.",
  "FEATURE_NOT_IN_PLAN": "This feature isn't included in your plan. Contact Xtreed.",
  "FEATURE_UNKNOWN": "Unknown feature: {{features}}",
  "FEATURE_NOT_AVAILABLE": "This feature isn't available in this members area.",
  "TENANT_HOST_REQUIRED": "This route must be accessed through the members area address.",
  "TENANT_SESSION_UNBOUND": "Your session isn't linked to a members area. Please sign in again.",
  "TENANT_SESSION_MISMATCH": "Your session doesn't belong to this members area.",
  "ROLES_NOT_AUTHENTICATED": "User not authenticated.",
  "ROLES_INSUFFICIENT_PERMISSION": "You don't have permission to access this resource.",
  "SESSION_TOKEN_EXPIRED": "Your session has expired. Please sign in again.",
  "SESSION_TOKEN_INVALID": "Invalid token.",
  "SESSION_UNAUTHORIZED": "Unauthorized."
}
